import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
        <h1>Career History</h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="02/2025 – Present"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Software Engineer</h3>
            <h4 className="vertical-timeline-element-subtitle">ExpertEase | Adelaide, Australia</h4>
            <p>
              Agentic LLM chatbots, RAG systems, microservice architecture, Django & FastAPI backends, Azure cloud migration, CI/CD pipelines with TDD
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="07/2024 – 01/2025"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Associate Software Engineer</h3>
            <h4 className="vertical-timeline-element-subtitle">Zones IT Solutions | Islamabad, Pakistan</h4>
            <p>
              Golang, Node.js, NestJS, React microservices; real-time search systems; API gateway development; improved code coverage by ~20% across 40,000+ LOC
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="03/2023 – 03/2024"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Full Stack Developer</h3>
            <h4 className="vertical-timeline-element-subtitle">Techception | Islamabad, Pakistan</h4>
            <p>
              CRM for Realtor markets (US, UK, Canada) with TypeScript, Next.js & Prisma; improved Lighthouse scores from 10% to 90%; Headless CMS with Strapi
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="07/2022 – 12/2022"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Project Manager | Full Stack Developer</h3>
            <h4 className="vertical-timeline-element-subtitle">Sharp Edge | Lahore, Pakistan</h4>
            <p>
              Led 2 enterprise MERN stack projects with cross-European teams; migrated WordPress sites to React with Redux & REST APIs; built Scrum & automation guides
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="01/2022 – 07/2022"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Junior Full Stack Developer</h3>
            <h4 className="vertical-timeline-element-subtitle">The Moonshot Factory | Remote</h4>
            <p>
              CI/CD with GitHub Actions on Azure; fit-gap analysis saving 4 months of development; cost-benefit security analysis accelerating product scaling by 20%
            </p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;